import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Text, useUtility, Stack } from '@hub-la/design-system';
import { UploadStatus } from '@hub-la/fe-asset';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { ProgressBar } from './progress-bar.js';

let _ = t => t,
  _t;
const FileName = styled(Text)(_t || (_t = _`
  word-break: break-all;
`));
const Item = ({
  name,
  progress,
  status
}) => {
  const {
    palette
  } = useUtility();
  const getStatus = status => {
    if (status === UploadStatus.SUCCESS) {
      return jsx(CheckCircleIcon, {
        sx: {
          fill: palette('primary')
        }
      });
    } else {
      return jsx(CloseIcon, {
        sx: {
          cursor: 'pointer'
        }
      });
    }
  };
  return jsxs(Stack, Object.assign({
    flexDirection: "row",
    alignItems: "center",
    paddingX: 6,
    marginBottom: 1
  }, {
    children: [jsxs(Stack, Object.assign({
      width: "100%",
      marginRight: 4,
      paddingY: 3
    }, {
      children: [jsx(FileName, Object.assign({
        variant: "body2",
        marginBottom: 1,
        color: "onSurface"
      }, {
        children: name
      })), jsx(ProgressBar, {
        progress: status === UploadStatus.SUCCESS ? 100 : progress
      })]
    })), getStatus(status)]
  }));
};

export { Item };
